import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { apiPut } from "../../utils/api";
import { useLanguage } from "../../contexts/LanguageContext";
import { AdminField } from "./AdminFormDialog";
import { AdminPanel, AdminBtnPrimary } from "./AdminUI";
import { Input } from "../ui/input";
import { RichEditor } from "../subcomponents/RichEditor";

type Props = {
  item: any;
  onSaved: (item: any) => void;
};

export const AdminAdmissionGuidePanel: React.FC<Props> = ({ item, onSaved }) => {
  const { t } = useLanguage();
  const [title, setTitle] = useState("");
  const [academicYear, setAcademicYear] = useState("");
  const [contactPhones, setContactPhones] = useState("");
  const [introHtml, setIntroHtml] = useState("");
  const [contentHtml, setContentHtml] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setTitle(item?.title || "Guide d'inscription");
    setAcademicYear(item?.academicYear || "");
    setContactPhones(item?.contactPhones || "");
    setIntroHtml(item?.introHtml || "");
    setContentHtml(item?.contentHtml || "");
  }, [item]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await apiPut("/admission-guide", {
        title, academicYear, contactPhones, introHtml, contentHtml,
      });
      onSaved(res.item);
      toast.success(t.admin.admissionGuideSaved);
    } catch (e: any) {
      toast.error(e?.messageText || "Erreur");
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminPanel>
      <div style={{ padding: "24px 28px 28px" }}>
        <p style={{ color: "#666", fontSize: 13, marginTop: 0, marginBottom: 20 }}>
          {t.admin.admissionGuideDesc}
        </p>

        <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          <div style={{ flex: "1 1 320px" }}>
            <AdminField label={t.admin.admissionGuideTitle}>
              <Input value={title} onChange={(e: any) => setTitle(e.target.value)} />
            </AdminField>
          </div>
          <div style={{ flex: "0 1 200px" }}>
            <AdminField label={t.admin.admissionGuideYear}>
              <Input value={academicYear} onChange={(e: any) => setAcademicYear(e.target.value)} placeholder="2026-2027" />
            </AdminField>
          </div>
        </div>

        <AdminField label={t.admin.admissionGuideContact}>
          <Input value={contactPhones} onChange={(e: any) => setContactPhones(e.target.value)} placeholder="+243 ..., +243 ..." />
        </AdminField>

        <AdminField label={t.admin.admissionGuideIntro}>
          <RichEditor value={introHtml} onChange={setIntroHtml} minHeight={100} />
        </AdminField>

        <AdminField label={t.admin.admissionGuideContent}>
          <RichEditor value={contentHtml} onChange={setContentHtml} minHeight={420} />
        </AdminField>

        <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
          <AdminBtnPrimary onClick={handleSave} disabled={saving}>
            {saving ? "..." : t.admin.save}
          </AdminBtnPrimary>
        </div>
      </div>
    </AdminPanel>
  );
};
